
import action from '../components/action.vue';

export default {
    components: { action },

    created() {
    },

    activated() {
        let t = this;
        t.loadData();
    },

    methods: {

        loadData() {

            let t = this;

            let params = {};

            axios.get('coupon', { params: params }).then(res => {
                if (res.data.status == 1) {
                    res.data.options.items.forEach(item => {
                        item.showActions = false;
                    });
                    t.list.item = res.data.options.items;
                }
            });

        },


        delItem(item) {

            let t = this;

            A.safety('确定要删除该优惠券吗？<br>如已被领取，不会收回优惠券').then(function (res) {
                if (res) {
                    axios.put('coupon/' + item.id, { status: 0 }).then(res => {
                        if (res.data.status == 1) {
                            t.list.item.remove(item);
                        }
                    });
                }
            });

        },

        newItem() {
            let t = this;

            this.$parent.disabledScroll = true;
            this.modal = 'coupon';
            t.couponForm = {
                days: 7,
                min_amount: '',
                discount_amount: '',
                quantity: '',
                desc: '',
            };
        },

        editItem(item) {
            this.$parent.disabledScroll = true;
            this.modal = 'coupon';
            this.couponForm = getFields(item, ['id', 'days', 'min_amount', 'discount_amount', 'quantity', 'desc'])
        },

        closeModal() {
            this.modal = '';
            this.$parent.disabledScroll = false;
        },

        saveCouponForm() {

            let t = this;

            if (t.busying)
                return;

            let f = t.couponForm;

            t.errMsg = "";

            if (!f.days || !/^\d{1,}$/.test(f.days)) {
                t.errMsg = "请填写正确的有效天数";
                return;
            }

            if (!f.min_amount || !/^\d{1,}$/.test(f.min_amount)) {
                t.errMsg = "请填写正确的最低金额";
                return;
            }

            if (!f.discount_amount || !/^\d{1,}$/.test(f.discount_amount)) {
                t.errMsg = "请填写正确的优惠金额";
                return;
            }

            if (!f.quantity || !/^\d{1,}$/.test(f.quantity)) {
                t.errMsg = "请填写正确的发放数量";
                return;
            }

            t.busying = true;

            if (f.id) {
                axios.put('coupon/' + f.id, f).then(res => {

                    t.busying = false;

                    if (res.data.status == 1) {
                        A.toast('保存成功');
                        t.couponForm = {
                            days: 7,
                            min_amount: '',
                            discount_amount: '',
                            quantity: '',
                            desc: '',
                        };
                        t.closeModal();
                    }
                });
            }
            else {
                axios.post('coupon', f).then(res => {

                    t.busying = false;

                    if (res.data.status == 1) {
                        A.toast('保存成功');
                        t.list.item.unshift(res.data.options);
                        t.couponForm = {
                            days: 7,
                            min_amount: '',
                            discount_amount: '',
                            quantity: '',
                            desc: '',
                        };
                        t.closeModal();
                    }
                });
            }

        },

        shareCoupon(item) {
            let t = this;
            t.initSharing(`满${item.min_amount}减${item.discount_amount}优惠券限时领取`,
                '/pages/index/index?path=coupon&params=' + JSON.stringify({ 'id': item.id }));
            A.show('请继续点击右上角“···”按钮<br>选择“发送给朋友”', '继续操作', 'success');
        },

    },

    data() {
        return {
            busying: false,
            couponForm: {
                days: 7,
                min_amount: '',
                discount_amount: '',
                quantity: '',
                desc: '',
            },
            errMsg: '',
            modal: '',
            list: {
                item: []
            },
        };
    },
};
